<!-- <ng-container >
    <ag-webtemplate (onLanguageSelected)="changeLanguage($event)"></ag-webtemplate>
</ng-container> -->

<custom-layout (languageSelected)="changeLanguage($event)"></custom-layout>
